import React from 'react';
import {
  ListingLabelContext,
  ExternalAuthContext,
  BuyerAgreementContextProvider,
} from 'contexts';
import AppointmentBookingExternal from './AppointmentBookingExternal';
import AppointmentBookingInternal from './AppointmentBookingInternal';

const AppointmentBooking = props => {
  // props passed in through the apointmentbooking.module.js
  // extAuth and apointmentDetails were part of the bindings
  const { extAuth } = props;

  if (extAuth) {
    return (
      <ExternalAuthContext.Provider
        value={{
          auth: extAuth,
        }}
      >
        <AppointmentBookingExternal {...props} />
      </ExternalAuthContext.Provider>
    );
  }

  return <AppointmentBookingInternal {...props} />;
};

const AppointmentBookingContextWrapped = props => (
  <BuyerAgreementContextProvider>
    <ListingLabelContext.Provider
      value={{
        labelOverrideMap: props.$rootScope.labelOverrideMap,
        getAvailability: props.$rootScope.getAvailability,
        getLabel: props.$rootScope.getLabel,
      }}
    >
      <AppointmentBooking {...props} />
    </ListingLabelContext.Provider>
  </BuyerAgreementContextProvider>
);

export default AppointmentBookingContextWrapped;
